import React, { useState } from "react";
import codes from "country-calling-code";
import { Select, MenuItem } from "@material-ui/core";
import useStyles from "./select-country-code.styles";

interface SelectCountryCodeProps {
  className: string;
  valueDefault?: string;
  onChange(e: string): void;
}
const countryCodes = [];
codes.forEach(({ isoCode3: country, countryCodes: countrycode }) => {
  countrycode.forEach((code) => {
    countryCodes.push({ key: `${country}-${code}`, code });
  });
});

const sortedCodes = countryCodes.sort((a, b) => (a.code < b.code ? -1 : 1));

const SelectCountryCode = ({
  className,
  valueDefault,
  onChange,
}: SelectCountryCodeProps) => {
  const classes = useStyles();

  const defaultCode = sortedCodes.find(({ code }) => code === valueDefault);
  const [selected, setSelected] = useState(defaultCode || sortedCodes[0]);
  const handleChange = ({ target }) => {
    const find = sortedCodes.find((code) => code.key === target.value.slice(1));
    setSelected(find);
    onChange(find.code);
  };

  return (
    <Select
      className={className}
      inputProps={{
        "data-testid": "selectCountryCodeTestId",
      }}
      value={selected.code}
      onChange={handleChange}
    >
      <MenuItem className={classes.hiddenMenuItem} value={selected.code}>
        {selected.code}
      </MenuItem>
      {sortedCodes.map(({ key }) => (
        <MenuItem key={key} value={`#${key}`}>
          {key}
        </MenuItem>
      ))}
    </Select>
  );
};

SelectCountryCode.defaultProps = {
  valueDefault: "",
};

export default SelectCountryCode;
